import { emailRegExp, phoneRegExp, zipRegExp } from 'views/consts/validation'

export const getPattern = (inputType, name) => {
  switch (inputType) {
    case 'email':
      return emailRegExp.source
    case 'tel':
      return phoneRegExp.source
    case 'text':
      if (name === 'zip') {
        return new RegExp(zipRegExp).source
      }
      return null
    default:
      return null
  }
}
